export default __webpack_public_path__ + "static/ritvi_bw-0c39422a590dce786d44f5f09b1be563.jpg";